import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = ["Planung und Design", "Bauleitung", "Materialauswahl", "Handwerkliche Ausführung"];
export default function ServicesGridTurnkeyRenovations() {
  return <section id="services-grid-schlüsselfertige-renovierungen" className="py-12 md:py-16 bg-background">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="flex flex-col justify-center">
            <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-6">
              Schlüsselfertige Renovierungen
            </h2>
            
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Komplettrenovierung aus einer Hand – von der Planung bis zur schlüsselfertigen Übergabe. Wir koordinieren alle Gewerke und sorgen für einen reibungslosen Ablauf.
            </p>
            
            <ul className="space-y-4 mb-10">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                  <span className="text-foreground font-medium">{feature}</span>
                </li>)}
            </ul>
            
            <div>
              <Button asChild size="lg" className="rounded-lg px-8">
                <Link to="/ContactPage">Angebot anfordern</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative w-full">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/turnkey_renovation_split_view.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/turnkey_renovation_split_view.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/turnkey_renovation_split_view.png-wvc-sizes" alt="Schlüsselfertige Renovierungen Vorher Nachher Vergleich" className="w-full h-auto rounded-2xl object-cover shadow-md" loading="lazy" />
          </div>

        </div>
      </div>
    </section>;
}